import React from 'react';
import { Row, Button, Col, Container, Header, PageContent, Alerts } from 'components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Margin } from 'styled-components-spacing';
import { BoldText } from './IpmaRegistration.styled';
import checkPermissions from '../../../helpers/checkPermissions';
import { connect } from 'react-redux';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.ma.ipmaRegistration',
    url: '/ma/ipma-registration',
  },
];

const IpmaRegistration = ({ userPermissions }) => {
  const { t } = useTranslation();

  const customButton = (to, content) => (
    <Button
      as={Link}
      to={to}
      style={{ width: 'auto', letterSpacing: '1.4px', padding: '18px 40px' }}
    >
      {content}
    </Button>
  );

  const cpdPermission = checkPermissions({ roles: ['ma_manage_cpd'] }, userPermissions);

  return (
    <>
      <Header breadcrumbs={breadcrumbs} title={t('page.ma.ipmaRegistration.title')} />
      <PageContent>
        <Container>
          <Margin bottom={{ md: 48 }}>
            <Alerts type="ma" />
          </Margin>

          <Col>
            <Margin bottom={{ xs: 32 }}>
              <Margin bottom={{ xs: 12 }}>
                <Row>
                  <BoldText>{t('page.ma.ipmaRegistration.welcome')}</BoldText>
                </Row>
              </Margin>
              <Row>
                <BoldText>{t('page.ma.ipmaRegistration.description')}</BoldText>
              </Row>
            </Margin>

            <Row>
              <Margin>{customButton('/ma/courses', t('page.ma.ipmaRegistration.courses'))}</Margin>
              {cpdPermission && (
                <Margin left={{ sm: 32 }} top={{ xs: 16, sm: 0 }}>
                  {customButton('/ma/cpd-management', t('page.ma.ipmaRegistration.cpdManagement'))}
                </Margin>
              )}
            </Row>
          </Col>
        </Container>
      </PageContent>
    </>
  );
};

const mapStateToProps = ({ user }) => ({
  userPermissions: user.userPermissions,
});

export default connect(mapStateToProps, null)(IpmaRegistration);
